<template>
    <div class="scroll-tracker">
        <ul class="sensitive-list">
            <li
                v-for="(item, index) in wordData"
                :key="index"
                @mouseover="mouseOnSensitive(item)"
                @mouseout="mouseOutSensitive"
                v-show="item.updateState != 'delete'"
            >
                <Checkbox class="all-check" @valueChange="checkHandler($event, item)" :data="item.checked" />
                <input
                    class="que-li-input"
                    @blur="blurHander(item)"
                    @keypress="keyPressHandler($event, item)"
                    :class="{ editing: currentId === item.uId }"
                    v-model="editVal"
                />
                <div class="que-li-txt" v-show="currentId !== item.uId">{{ item.word }}</div>
                <i class="i-class-edit" @click="editClick(item)" v-show="showEditorBtn && item.uId === onMouseoverId" v-if="isEdit"></i>
                <i class="i-class-delete" @click="deleteClick(item)" v-show="showEditorBtn && item.uId === onMouseoverId" v-if="isEdit"></i>
            </li>
        </ul>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import i18n from "@/i18n";

export default {
    name: "SensitiveList",
    props: ["data", "unableEdit"],
    data() {
        return {
            currentId: "",
            currentVal: "",
            editVal: "",
            showEditorBtn: false,
            onMouseoverId: ""
        };
    },
    components: {
        Checkbox
    },
    computed: {
        isEdit() {
            return this.unableEdit ? !this.unableEdit : true;
        },
        wordData() {
            return this.data;
        }
    },
    methods: {
        checkHandler(event, data) {
            this.$emit("checkChange", {
                checked: event.checked,
                uId: data.uId
            });
        },
        editClick(item) {
            setTimeout(() => {
                this.currentVal = item.word;
                this.editVal = item.word;
                this.currentId = item.uId;

                setTimeout(() => {
                    let input = document.querySelector(".sensitive-list .editing.que-li-input");
                    input && input.focus();
                }, 50);
            }, 50);
        },
        deleteClick(item) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.sensitiveWord.delWordConfim"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.commit("zhiji/editUpdateSensitive", {
                            type: "deleteContent",
                            wordItem: [item.uId]
                        });
                    }
                }
            });
        },
        emitEditEvent(item) {
            const newText = this.zhiji.strTrim(this.editVal);
            const isChanged = newText != this.currentVal;
            newText &&
                isChanged &&
                this.$store.commit("zhiji/editUpdateSensitive", {
                    type: "updateContent",
                    wordItem: {
                        ...item,
                        word: newText
                    }
                });
            this.currentId = "";
        },
        keyPressHandler(event, item) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.emitEditEvent(item);
        },
        blurHander(item) {
            this.emitEditEvent(item);
        },
        mouseOnSensitive(item) {
            this.onMouseoverId = item.uId;
            this.showEditorBtn = true;
        },
        mouseOutSensitive() {
            this.showEditorBtn = false;
        }
    }
};
</script>

<style lang="less" scoped>
.editing {
    display: block !important;
}
.sensitive-list {
    width: 680px;
    padding-bottom: 12px;
    li {
        display: inline-flex;
        align-items: center;
        padding: 2px 16px 2px 0;
        box-sizing: border-box;
        width: 49%;
        flex-wrap: wrap;
        cursor: pointer;
        .all-check {
            margin-right: 8px;
        }
        &:last-child {
            border: none;
        }
        .i-class-edit {
            position: relative;
            display: inline-block;
            width: 18px;
            height: 18px;
            margin: 0 5px 0 5px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -76px 0;
            &:hover {
                background-position: -76px -22px;
            }
        }
        .i-class-delete {
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -95px 0;
            vertical-align: -4px;
            margin-right: 4px;
            width: 18px;
            height: 18px;
            &:hover {
                background-position: -95px -22px;
            }
        }
    }

    .que-li-txt {
        height: 28px;
        line-height: 28px;
        max-width: 210px;
        margin-right: 10px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
    }
    .que-li-input {
        width: 210px;
        border: solid 1px #d8e4f0;
        border-radius: 2px;
        height: 100%;
        display: none;
        &:focus {
            border-color: #2088f3;
        }
    }
}
</style>
